import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-personal-area',
    templateUrl: './personal-area.component.html',
    styleUrls: ['./personal-area.component.css'],
    standalone: false
})
export class PersonalAreaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
